import styled, { css } from 'styled-components';

export const VerificationCodeContainer = styled.div(
  ({ theme: { spacers } }) => css`
    margin-bottom: ${spacers!.spacer15};
    display: flex;
    flex-direction: column;
  `
);

export const CodeInputLabel = styled.div<{ $isError: boolean }>(
  ({ theme: { admanColors, spacers }, $isError }) => css`
    font-size: 14px;
    line-height: 21px;
    color: ${$isError ? admanColors!.red.dark.fg[2] : admanColors!.gray.light.fg1[1]};
    margin-bottom: ${spacers!.spacer01};
  `
);

export const CodeInputError = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    font-size: 14px;
    line-height: 21px;
    color: ${admanColors!.red.dark.fg[2]};
    margin-top: ${spacers!.spacer01};
  `
);

export const CodeInputSeparator = styled.span`
  width: 16px;
`;

export const CodeInputStyled = styled.input<{ $isError: boolean }>(
  ({ theme: { admanColors }, $isError }) => css`
    height: 40px;
    flex: 1;
    border-radius: 8px;
    border: 1px solid ${$isError ? admanColors!.red.dark.fg[2] : admanColors!.gray.light.bg3[1]};
    font-size: 14px;
    line-height: 21px;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      appearance: none;
      margin: 0;
    }

    appearance: textfield;
  `
);

export const StyledCheckboxWrapper = styled.div`
  label > span {
    text-transform: none;
    font-weight: 400;
  }
`;
